import type { ReactNode } from "react";

import { PropHeroBackgroundIcon } from "@prophero-customers/components";

import { HeaderProvider } from "@/contexts/HeaderContext";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { MEDIA_QUERY } from "@/utils/mediaQueries";

import PropHeroHeader from "./PropHeroHeader";

type ScreenManagerLayoutProps = {
  children?: ReactNode;
};

/**
 * Shared layout for all screen managers (dev and prod).
 * Provides header and background; content is rendered as children.
 */
export default function ScreenManagerLayout({
  children,
}: ScreenManagerLayoutProps) {
  const isMobile = useMediaQuery(MEDIA_QUERY.mobile);
  return (
    <HeaderProvider>
      <PropHeroHeader />
      {!isMobile && <PropHeroBackgroundIcon />}
      {children}
    </HeaderProvider>
  );
}
